/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your measurements (waist must be larger than neck).`)
};

const es_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tus medidas (la cintura debe ser mayor que el cuello).`)
};

const de_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deine Maße ein (die Taille muss größer sein als der Hals).`)
};

const nl_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul je maten in (taille moet groter zijn dan nek).`)
};

const fr_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez vos mesures (la taille doit être supérieure au cou).`)
};

const it_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci le tue misure (la vita deve essere maggiore del collo).`)
};

const pt_br2_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe suas medidas (a cintura precisa ser maior que o pescoço).`)
};

const pt_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza as suas medidas (a cintura tem de ser maior do que o pescoço).`)
};

const ja_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`測定値を入力してください(腰周りは首周りより大きい必要があります)。`)
};

const zh_bf_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入你的测量数据（腰围必须大于颈围）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_hint", locale)
	if (locale === "en") return en_bf_hint(inputs)
	if (locale === "es") return es_bf_hint(inputs)
	if (locale === "de") return de_bf_hint(inputs)
	if (locale === "nl") return nl_bf_hint(inputs)
	if (locale === "fr") return fr_bf_hint(inputs)
	if (locale === "it") return it_bf_hint(inputs)
	if (locale === "pt-BR") return pt_br2_bf_hint(inputs)
	if (locale === "pt") return pt_bf_hint(inputs)
	if (locale === "ja") return ja_bf_hint(inputs)
	return zh_bf_hint(inputs)
};